import { render, staticRenderFns } from "./BirthMonthEvent.vue?vue&type=template&id=6cd4afec&scoped=true&"
import script from "./BirthMonthEvent.vue?vue&type=script&lang=js&"
export * from "./BirthMonthEvent.vue?vue&type=script&lang=js&"
import style0 from "./BirthMonthEvent.vue?vue&type=style&index=0&id=6cd4afec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd4afec",
  null
  
)

export default component.exports